import team3 from './../../images/team/pic3.jpg';
import team5 from './../../images/team/pic5.jpg';
import team6 from './../../images/team/pic6.jpg';
import team7 from './../../images/team/pic7.jpg';
import team8 from './../../images/team/pic8.jpg';
import team9 from './../../images/team/pic9.jpg';
import team10 from './../../images/team/pic10.jpg';
import team11 from './../../images/team/pic11.jpg';
import team12 from './../../images/team/pic12.jpg';
import team13 from './../../images/team/pic13.jpg';
import team14 from './../../images/team/pic14.jpg';
import team15 from './../../images/team/pic15.jpg';
import team16 from './../../images/team/pic16.jpg';
import classImg1 from './../../images/classes/psir.jpg';
import classImg2 from './../../images/classes/jishan.jpg';

export const leadership = [
	{
		image: classImg1,
		name: 'Rajesh Baghel',
		role: 'Principal',
		description:
			'Meet Rajesh Sir, the Principal of Bright Future School. With a strong commitment to education and student development, he leads the school with vision and dedication, ensuring every student achieves their fullest potential.',
		detailLink: '/teachers-details',
	},
	{
		image: classImg2,
		name: 'Jishan Foda',
		role: 'Managing Trustee',
		description:
			'A guiding force behind Bright Future School, Jishan brings valuable experience and leadership to support the school’s vision and continued growth.',
	},
];

export const faculty = [
	{ image: team3, name: 'Arshadkhan Pathan', role: 'B.Ed' },
	{ image: team5, name: 'Naurin Shaikh', role: 'B.Com' },
	{ image: team6, name: 'Nilofar Shekh', role: 'D.EI.Ed' },
	{ image: team7, name: 'Rashida Alirajpur', role: 'B.A' },
	{ image: team8, name: 'Dipti Gavit', role: 'B.Ed' },
	{ image: team9, name: 'Najnin Makrani', role: '' },
	{ image: team10, name: 'Batul Vohra', role: 'B.Com' },
	{ image: team11, name: 'Farhin Shaikh', role: 'B.A' },
	{ image: team12, name: 'Jil Baria', role: 'B.A' },
	{ image: team13, name: 'Tarannum Shaikh', role: 'B.Ed' },
	{ image: team14, name: 'Sabiya Makrani', role: 'B.Ed' },
	{ image: team15, name: 'Parkash Rathva', role: 'B.Ed' },
	{ image: team16, name: 'Shilpa Tadvi', role: 'B.A' },
];

// Principal + faculty — used on homepage slider
export const sliderTeachers = [
	{
		image: classImg1,
		name: leadership[0].name,
		role: leadership[0].role,
		link: leadership[0].detailLink,
	},
	...faculty.map((teacher) => ({
		...teacher,
		link: '/teachers',
	})),
];
